import FocusableCard from './FocusableCard';

export default FocusableCard;
